import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, OverlayTrigger } from "components/common";
const Explanation = () => {
  const { t } = useTranslation("widgets");
  return /* @__PURE__ */ React.createElement("span", null, t("export_widget.enterprise_explanation"));
};
const ExportWidgetPlug = () => {
  const { t } = useTranslation("widgets");
  const title = t("export_widget.title");
  return /* @__PURE__ */ React.createElement(OverlayTrigger, { trigger: "click", title, overlay: /* @__PURE__ */ React.createElement(Explanation, null), placement: "bottom" }, /* @__PURE__ */ React.createElement(IconButton, { name: "download", title }));
};
export default ExportWidgetPlug;
